import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/marcellus/400.css";
import "@fontsource/instrument-sans/400.css";
import "@fontsource/instrument-sans/500.css";
import "@fontsource/instrument-sans/600.css";
import "@fontsource/noto-serif-devanagari/devanagari-400.css";
import App from "./App";
import "./style.css";
import "./design.css";

// Fragments never reach the Worker. Preserve printed QR links to the former
// Institute page, replacing this entry so Back cannot revisit the redirect.
function redirectLegacyInstitute(): boolean {
  if (window.location.pathname === "/" && window.location.hash === "#page-b") {
    window.location.replace("https://bharatheeya.org/");
    return true;
  }
  return false;
}

window.addEventListener("hashchange", redirectLegacyInstitute);

if (!redirectLegacyInstitute()) {
  const root = document.getElementById("root")!;
  const application = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  if (root.hasChildNodes()) {
    ReactDOM.hydrateRoot(root, application);
  } else {
    ReactDOM.createRoot(root).render(application);
  }
}
